import { Box } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import pickUpOrder from '../../../assets/img/pickup-order.png';

export default function PickupOrderInputFileLabel() {
  const { t } = useTranslation('description');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        alignItems: 'flex-start',
      }}
    >
      <Box
        component="img"
        src={pickUpOrder}
        alt=""
        sx={{ maxWidth: '100%', height: 'auto' }}
      />
      <Box component="span" sx={{ hyphens: 'auto' }}>
        <Trans
          t={t}
          i18nKey="orders.deliver.modal.image_copyright_pickup"
          ns="description"
        >
          Attach the photo of the order you are{' '}
          <span className="text-primary fw-bold"> withdrawing</span>
        </Trans>
      </Box>
    </Box>
  );
}
